import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Skeleton } from "@libs/rubick";
function MetricCard({ helperText, isLoading = false, label, loadingClassName = "w-24", value }) {
    return /*#__PURE__*/ _jsx(Card, {
        variant: "bordered",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-1",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text-xs font-medium uppercase tracking-wider text-gray-500",
                    children: label
                }),
                isLoading ? /*#__PURE__*/ _jsx(Skeleton, {
                    className: `h-8 ${loadingClassName}`
                }) : /*#__PURE__*/ _jsx("p", {
                    className: "text-2xl font-bold text-gray-900",
                    children: value
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-xs text-gray-500",
                    children: helperText
                })
            ]
        })
    });
}
export { MetricCard };
